// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_YKJEo","header":"header_MK3yC"};